import { Navigate } from 'react-router';

import { useWaitUserInfoWithRole } from '~domains/auth';

import { ROUTES } from '~shared/config/routes';
import { Loader } from '~shared/ui/loader';

export const SignedScreen = () => {
  const userInfoQuery = useWaitUserInfoWithRole({
    retry: 3,
    retryDelay: 1000,
  });

  if (userInfoQuery.isFetching) {
    return <Loader />;
  }

  return <Navigate to={ROUTES.partner.applicationMenu} />;
};
